export enum SnackBarColor {
    DANGER="danger",
    WARN="warn",
    SUCCESS="success"
}